import { errorTypes } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

export const getErrorTypes = errors => {
  if (!errors) return {}
  return {
    locationIdEmpty: errors.find(error => error.type === errorTypes.locationIdEmpty),
    invalidLocationError: errors.find(error => error.type === errorTypes.invalidLocationForCarrierService),
  }
}

export const getLocationError = errors => {
  const { invalidLocationError, locationIdEmpty } = getErrorTypes(errors)
  if (invalidLocationError) return invalidLocationError
  if (locationIdEmpty) return locationIdEmpty

  return null
}

export const getLocationErrorMessage = (errors, value) => {
  const { invalidLocationError } = getErrorTypes(errors)
  if (invalidLocationError) {
    return 'La región de destino no es compatible con el servicio logístico seleccionado. Seleccione una ubicación diferente o elija otro servicio logístico.'
  }

  if (!value) {
    return 'Este campo es requerido'
  }
}
